import { Component, OnInit } from '@angular/core';
import { PageService } from '@services/page.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as _ from 'lodash';
@Component({
  selector: 'app-pabout',
  templateUrl: './pabout.component.html',
  styleUrls: ['./pabout.component.sass']
})
export class PaboutComponent implements OnInit {

  application = "page";
  component = 'm';
  params: any = [];
  comments: any = [];
  id = "";
  response: any = [];
  page_content="";
  constructor(private _pageService: PageService,private route: ActivatedRoute, private _global: GlobalService) {
    this._pageService.application({ name: 'abou' }).subscribe(
      pageData => {
        if (this._global.getVal(pageData, 'response.numFound', 0) > 0) {
          this.response = this._global.getVal(pageData, 'response', {});
          this.page_content =this._global.getVal(this.response, 'content', 'Page is not available!'); 
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  ngOnInit() {
  }

}
